import { Link } from 'react-router-dom';
import { EmptyState } from '../components/ui/EmptyState';
import { Button } from '../components/ui/Button';

export function NotFoundPage(): React.JSX.Element {
  return (
    <div style={{ padding: 'var(--space-8)' }}>
      <EmptyState
        title="Page not found"
        body="The page you're looking for doesn't exist."
        action={
          <Link to="/">
            <Button variant="primary">Back to Dashboard</Button>
          </Link>
        }
      />
    </div>
  );
}
